<template>
  <div class="survey-status-icons" v-if="survey.status === 'FINISHED'">
    <el-popover v-if="alert" trigger="hover" placement="top">
      <p>Cliente com alerta</p>
      <div slot="reference" class="name-wrapper">
        <i class="ti-alert text-danger" ></i>
      </div>
    </el-popover>

    <el-popover v-if="!absent && accepted" trigger="hover" placement="top">
      <p>Nota: {{ score }}</p>
      <div slot="reference" class="name-wrapper">
        <i  class="ti-check text-success" ></i>
      </div>
    </el-popover>
    <el-popover v-else trigger="hover" placement="top">
      <p>Motivo: {{ reason }}</p>
      <div slot="reference" class="name-wrapper">
        <i  class="ti-close text-danger" ></i>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'survey-status-icons',

  props: {
    ticket: { required: true },
    survey: { required: true }
  },

  computed: {
    alert () {
      return this.survey ? this.survey.hasOwnProperty('data') && this.survey.data.alert : false
    },

    surveyed () {
      return this.survey ? this.survey.hasOwnProperty('data') && this.survey.status === 'SYNCED' : false
    },

    score () {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.hasOwnProperty('refrigerator') ? this.survey.data.refrigerator.score : 0
    },

    absent () {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.hasOwnProperty('absent') ? this.survey.data.absent && this.survey.data.absent !== 'false' : false
    },

    accepted () {
      return this.survey && this.survey.hasOwnProperty('data') && this.survey.data.accepted && this.survey.data.accepted !== 'false'
    },

    reason () {
      return this.absent ? this.survey.data.reasonNotPresent : !this.accepted ? this.survey.data.reasonNotAccepted : '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyStatusIcons.vue